export const CANCEL_METHOD = {
  QUESTIONNAIRE: 'questionnaire',
  CS_SUPPORT: 'cs_support',
};

export const ITEM_TYPE = {
  CHOICE: 'choice',
  TEXT: 'text',
  NO_TYPE: 'no-type',
};

export const TITLE_I18N_KEY = {
  MAIN: {
    [ITEM_TYPE.CHOICE]: 'account.cancelReasonTitle',
    [ITEM_TYPE.TEXT]: 'account.cancelReasonOthers',
    [ITEM_TYPE.NO_TYPE]: 'account.cancelReasonTitle',
  },
  SUB: {
    [ITEM_TYPE.CHOICE]: 'account.cancelReasonText',
    [ITEM_TYPE.TEXT]: '',
    [ITEM_TYPE.NO_TYPE]: 'account.cancelReasonText',
  },
};

export const DIALOG_TYPE = {
  CONFIRM: 'CONFIRM',
  ERROR: 'ERROR',
};

export const DIALOG_I18N_KEY = {
  TITLE: {
    [DIALOG_TYPE.CONFIRM]: 'account.cancelSubscriptionModal.title',
    [DIALOG_TYPE.ERROR]: 'account.cancelError.title',
  },
  CONTENT: {
    [DIALOG_TYPE.CONFIRM]: 'account.cancelSubscriptionModal.description',
    [DIALOG_TYPE.ERROR]: 'account.cancelError.text',
  },
  CLOSE_BUTTON: {
    [DIALOG_TYPE.CONFIRM]: 'account.cancelSubscriptionModal.dismissButtonText',
    [DIALOG_TYPE.ERROR]: 'account.cancelError.dismissButtonText',
  },
  CONFIRM_BUTTON: {
    [DIALOG_TYPE.CONFIRM]: 'account.cancelSubscriptionModal.confirmButtonText',
    [DIALOG_TYPE.ERROR]: 'account.cancelError.confirmButtonText',
  },
};

export const POST_TO = {
  ZENDESK: 'ZENDESK',
  SNAPASK: 'SNAPASK',
};

export const POST = {
  GET_DATA: {
    [POST_TO.ZENDESK]: ({
      name,
      billingCycle,
      reason,
      choice,
      content,
      placeholder = '-',
    }) => `
Subscription plan: ${name || placeholder}

Subscription billing cycle: ${billingCycle || placeholder}

Reason of cancelling - main: ${reason || placeholder}

Reason of cancelling - detail: ${choice || placeholder}

Comments: ${content || placeholder}`,
    [POST_TO.SNAPASK]: ({
      questionnaire,
      currentItem,
      currentChoice,
      content,
    }) => ({
      questionnaire_response: {
        questionnaire_id: questionnaire.questionnaireId,
        items_attributes: [
          {
            questionnaire_item_id: currentItem.questionnaireItemId,
            choices_attributes: [
              {
                questionnaire_choice_id: currentChoice.questionnaireChoiceId,
              },
            ],
            content,
          },
        ],
      },
    }),
  },
};

export const CANCELLATION_DIALOG_I18N_KEY = {
  TITLE: 'account.cancelSentModal.title',
  CONTENT: 'account.cancelSentModal.text',
  CONFIRM_BUTTON: 'account.cancelSentModal.dismiss',
};



// WEBPACK FOOTER //
// ./app/constants/cancelSubscription.js